import iframesPromise from './iframes';
import visibilityChangeHandler, { openChatPanel, closeChatPanel } from './visibilityChangeHandler';

let onVisibilityChange = () => {};
let onBotEventHandler = () => {};
let onActivityHandler = () => {};
let onUnreadMessagesHandler = () => {};

const apiPromise = iframesPromise.then(iframes => {
  let webChatReady = false;
  const historicalCalls = [];
  const setWebChatReady = isReady => {
    webChatReady = isReady;
  };

  const functions = {
    // Expose a send message function
    sendMessage: text => {
      iframes.chatWindowFrame.contentWindow.postMessage({ type: 'sendMessage', text }, '*');
    },

    // Expose a send user data function - data = { type? = 'SINGLE' | 'ARRAY', key, value }
    sendUserData: data => {
      iframes.chatWindowFrame.contentWindow.postMessage({ type: 'sendUserData', data }, '*');
    },

    toggleChatPanelVisible: () => {
      visibilityChangeHandler();
    },

    onVisibilityChange: handler => {
      onVisibilityChange = handler;
    },

    visibilityChange: visible => {
      onVisibilityChange(visible);
    },

    openChatPanel,

    closeChatPanel,

    clearHistory: () => {
      iframes.chatWindowFrame.contentWindow.postMessage({ type: 'clearHistory' }, '*');
    },

    createNewUser: () => {
      iframes.chatWindowFrame.contentWindow.postMessage({ type: 'createNewUser' }, '*');
    },

    jumpToNode: ({ scriptId, nodeId }) => {
      // close intro page
      iframes.chatWindowFrame.contentWindow.postMessage(
        {
          type: 'closeIntro'
        },
        '*'
      );

      const text = `/jumpToNode /${scriptId}/${nodeId}`;
      iframes.chatWindowFrame.contentWindow.postMessage({ type: 'sendMessage', text }, '*');
    },

    botEvent: botEvent => {
      onBotEventHandler(botEvent);
    },

    onBotEvent: botEventHandler => {
      onBotEventHandler = botEventHandler;
    },

    activity: activity => {
      onActivityHandler(activity);
    },

    onActivity: activityHandler => {
      onActivityHandler = activityHandler;
    },

    scrollToBottom: () => {
      iframes.chatWindowFrame.contentWindow.postMessage({ type: 'scrollToBottom' }, '*');
    },

    isWebChatReady: () => webChatReady,

    unreadMessages: count => {
      onUnreadMessagesHandler(count);
    },

    onUnreadMessages: unreadMessagesHandler => {
      onUnreadMessagesHandler = unreadMessagesHandler;
    }
  };

  const api = (...args) => {
    if (!functions[args[0]]) {
      console.error(`Couldn't find API function ${args[0]}`);
      return null;
    }
    return functions[args[0]](...args.slice(1));
  };

  let queue = window.Ambit.q || [];
  const nonBufferedApiCalls = [];

  const flushApiQueue = apiMethodsToFlush => {
    // Allow flushing only certain methods from the queue
    if (apiMethodsToFlush) {
      nonBufferedApiCalls.push(...apiMethodsToFlush);
      queue.filter(item => apiMethodsToFlush.includes(item[0])).forEach(item => api(...item));
      queue = queue.filter(item => !apiMethodsToFlush.includes(item[0]));

      return;
    }

    queue.forEach(item => {
      api(...item);
      // Cache historical calls after execution
      if (['sendUserData'].includes(item[0])) {
        if (
          !historicalCalls.some(
            call => call[0] === item[0] && JSON.stringify(call[1]) === JSON.stringify(item[1])
          )
        ) {
          historicalCalls.push(item);
        }
      }
    });
    queue = [];
    window.Ambit = api;
  };

  const replayHistoricalCalls = () => {
    if (historicalCalls.length > 0) {
      historicalCalls.forEach(args => api(...args));
    }
  };

  window.Ambit = (...args) => {
    if (nonBufferedApiCalls.indexOf(args[0]) !== -1) {
      return api(...args);
    }

    return queue.push(args);
  };

  flushApiQueue(['onVisibilityChange', 'visibilityChange', 'isWebChatReady']);

  const queueEmpty = () =>
    queue.filter(item => item[0] === 'sendMessage' || item[0] === 'jumpToNode').length === 0;

  return {
    flushApiQueue,
    botEvent: functions.botEvent,
    activity: functions.activity,
    unreadMessages: functions.unreadMessages,
    queueEmpty,
    setWebChatReady,
    replayHistoricalCalls
  };
});

export default apiPromise;



// WEBPACK FOOTER //
// ./src/initialiser/api.js